import { AxiosResponse } from 'axios';
import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { GetManageMembersDataProps, ManageMembersInvitePayload } from '@nx-frontend/shared/types';

export async function getManageMembersData(props: GetManageMembersDataProps): Promise<AxiosResponse['data']> {
  try {
    return await axiosClient.get(
      `${generalEnv.nextApiPath}/manage-members?orgId=${props.orgId}&workspaceId=${props.workspaceId}`
    );
  } catch (err) {
    throw new Error('Internal error');
  }
}

export async function inviteToPortal(props: ManageMembersInvitePayload): Promise<AxiosResponse['data']> {
  try {
    return await axiosClient.post(`${generalEnv.nextApiPath}/manage-members/invite`, props);
  } catch (err) {
    throw new Error('Internal error');
  }
}
